import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';

import { buttonVariants } from './button-variants';
import { cn } from '@/lib/cn';
import { Loader } from '../loader';

interface ButtonProps {
  loading?: boolean;
}

function Button({
  className,
  variant,
  size,
  asChild = false,
  loading = false,
  children,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  } & ButtonProps) {
  const Component = asChild ? Slot : 'button';
  return (
    <Component
      data-slot="button"
      className={cn(
        buttonVariants({ variant, size, className }),
        loading && 'disabled:bg-primary-80 disabled:text-primary-30'
      )}
      {...props}
    >
      {loading && <Loader className="text-neutral-100" />}
      {children}
    </Component>
  );
}

export { Button };
